import carIcon from "@/assets/type-icons/car.webp";
import truckIcon from "@/assets/type-icons/truck.webp";
import tractorIcon from "@/assets/type-icons/tractor.webp";
import motoIcon from "@/assets/type-icons/moto.webp";
import quadIcon from "@/assets/type-icons/quad.webp";
import jetskiIcon from "@/assets/type-icons/jetski.webp";
import boatIcon from "@/assets/type-icons/speed-boat.avif";

const ICONS = {
  car: carIcon,
  pkw: carIcon,
  truck: truckIcon,
  trucks: truckIcon,
  lkw: truckIcon,
  tractor: tractorIcon,
  agri: tractorIcon,
  agrar: tractorIcon,
  moto: motoIcon,
  bike: motoIcon,
  motorrad: motoIcon,
  atv: quadIcon,
  quad: quadIcon,
  jetski: jetskiIcon,
  "jet ski": jetskiIcon,
  boat: boatIcon,
  boot: boatIcon,
};

export function vehicleTypeIconAvailable(type) {
  return Boolean(ICONS[(type || "").toString().trim().toLowerCase()]);
}

export default function VehicleTypeIcon({ type, className = "h-5 w-5" }) {
  const src = ICONS[(type || "").toString().trim().toLowerCase()];
  if (!src) return null;
  return (
    <img
      src={src}
      alt=""
      className={`${className} object-contain shrink-0`}
      loading="lazy"
    />
  );
}
